/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useMemo, useState } from "react";
import useFormatById from "src/hooks/utils/useFormatById";
import { useTimer } from "./useTimer";
import { useDispatch, useSelector } from "react-redux";
import actions from "src/store/profileMain/actions";
import authActions from "src/store/auth/actions";
import ConfirmPin from "./ConfirmPin";
import { useNavigate } from "react-router";
import { current } from "@reduxjs/toolkit";
import { ReactComponent as ArrowLeftIcon } from "src/assets/static/images/arrow-left.svg";
import StrongPasswordValidation from "src/containers/ProfileMain/strongPasswordValidation";
const AuthorizationCode = ({
  pId,
  isPasswordRecover,
  setIsPasswordRecover,
  setProgressBarArr,
  setLoginWithCode,
  loginWithCode,
  isPasswordAuth,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const f = useFormatById();
  const [currentWizard, setCurrentWizard] = useState(0);

  const { pinTimer, setPinTimer } = useTimer();
  const [newPassword, setNewPassword] = useState("");
  const [repeateNewPassword, setRepeateNewPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const { success, exceptionCode } = useSelector(
    (state) => state.auth?.passwordRecoveredSuccessfully
  );
  const validatePasswordMatch = (password, confirmPassword) => {
    const passwordRegex = /^.{8,}$/;
    if (!passwordRegex.test(password)) {
      return "Password must be at least 8 characters long";
    }

    if (password !== confirmPassword) {
      return "Passwords do not match";
    }

    return "";
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    setPasswordError(validatePasswordMatch(value, repeateNewPassword));
  };

  const handleRepeateNewPasswordChange = (e) => {
    const value = e.target.value;
    setRepeateNewPassword(value);
    setPasswordError(validatePasswordMatch(newPassword, value));
  };

  const timerTime_Global = useSelector(
    (state) => state.profileMain?.timerTime_Global
  );

  useEffect(() => {
    if (success) {
      setIsPasswordRecover(false);
      dispatch(authActions.setRecoverpassword(false));
      setLoginWithCode(false);
    }
  }, [success, dispatch]);
  const sendOTPSuccess = useSelector((state) => state.auth.sendOTPSuccess);
  useEffect(() => {
    if (!timerTime_Global) {
      const minutes = timerTime_Global === false ? 3 : 0;
      setPinTimer(minutes * 60);
      dispatch(actions.setSendOTPToUser(false));
    }
  }, [timerTime_Global, dispatch, setPinTimer, sendOTPSuccess]);

  const timerExpired = !(pinTimer > 0);
  const [pinCode, setPinCode] = useState(0);
  const [showPinInput, setShowPinInput] = useState(true);

  useEffect(() => {
    if (sendOTPSuccess) {
      setShowPinInput(true);
      dispatch(authActions.setLoginSendOTP(false));
    }
  }, [sendOTPSuccess]);

  const pinCodeDisabled = useMemo(() => timerExpired, [timerExpired]);
  const checkUserObj = useSelector((state) => state.auth.checkUserObj);
  const otpIsValidate = useSelector((state) => state.auth.otpIsValidate);

  useEffect(() => {
    if (
      (currentWizard === 0 && checkUserObj?.maskedMobile) ||
      (currentWizard === 1 && sendOTPSuccess === true) ||
      (currentWizard === 2 && otpIsValidate)
    ) {
      if (!isPasswordRecover) setCurrentWizard((item) => item + 1);
      else {
        if (currentWizard <= 2) {
          setCurrentWizard((item) => item + 1);
          setProgressBarArr((item) =>
            item.map((x, index) => {
              if (currentWizard === index) {
                if (
                  currentWizard === 1 &&
                  !x.isActive &&
                  x.progressNumber === 3
                )
                  return x;

                return {
                  ...x,
                  isActive: true,
                };
              }
              return x;
            })
          );
        }
      }
    }
  }, [checkUserObj, dispatch, sendOTPSuccess, otpIsValidate]);

  useEffect(() => {
    if (
      !checkUserObj?.isRegistered &&
      checkUserObj?.isClient &&
      checkUserObj?.maskedMobile === null
    ) {
      dispatch(authActions.setIsIdentomat(true));
    }
  }, [checkUserObj]);
  useEffect(() => {
    if (
      checkUserObj?.isRegistered &&
      checkUserObj?.isClient &&
      checkUserObj?.maskedMobile === null
    ) {
      dispatch(authActions.setIsIdentomat(true));
    }
  }, [checkUserObj]);
  const handleWizardChange = () => {
    if (!isPasswordRecover) {
      if (currentWizard === 0) {
        dispatch(authActions.getCheckuser(pId));
      }

      if (currentWizard === 1) {
        dispatch(authActions.getLoginSendOTP(pId));
      }

      if (currentWizard === 2) {
        if (!checkUserObj?.isRegistered)
          dispatch(
            authActions.getRegisterUser({
              pId: pId,
              acceptedTerms: true,
              otp: pinCode,
            })
          );
        else {
          dispatch(
            authActions.getLoginwithcode({
              personalNumber: pId,
              otp: pinCode,
            })
          );
        }
      }
      // }
    } else {
      if (currentWizard === 0) {
        dispatch(authActions.getCheckuser(pId));
      }

      if (currentWizard === 1) {
        dispatch(authActions.getLoginSendOTP(pId));
      }

      if (currentWizard === 2) {
        dispatch(
          authActions.getValidateotp({
            personalNumber: pId,
            otp: pinCode,
          })
        );
      }

      if (currentWizard === 3)
        dispatch(
          authActions.getRecoverpassword({
            personalNumber: pId,
            otp: pinCode,
            newPassword: newPassword,
            confirmNewPassword: repeateNewPassword,
          })
        );
    }
  };

  useEffect(() => {
    if (
      currentWizard === 0 &&
      checkUserObj?.isRegistered &&
      checkUserObj?.isClient &&
      checkUserObj?.maskedMobile !== null
    ) {
      setLoginWithCode(true);
    }
  }, [currentWizard, checkUserObj]);

  const loading = useSelector((state) => state.auth.loading);
  const [agreeImedil, setAgreeImedil] = useState(false);
  const anyPasswordHasSpace =
    newPassword.includes(" ") || repeateNewPassword.includes(" ");

  const errorMessages = {
    426: f("passwrod-validate"),
    427: f("passwrod-dont-match"),
    374: f("passwrod-matches-old"),
  };
  const message = errorMessages[exceptionCode];
  return (
    <div>
      <div className="login-form-wizard" style={{ maxWidth: "376px" }}>
        <div>
          {false && (
            <span className="text-danger text-center mt-1">
              {f("errors.couldNotFindPinActivePolicy")}
            </span>
          )}
          {currentWizard === 1 && (
            <div className="text-center">
              <div className="info-text-li">
                {f("pay-phone-text-1")}{" "}
                <span style={{ color: "#FFC93C" }}>
                  {" "}
                  {checkUserObj?.maskedMobile}
                </span>{" "}
                {f("pay-phone-text-2")}{" "}
                <a
                  // href="https://www.imedil.ge/Auth/ChangeMobileNumber/"
                  // target="_blank"
                  onClick={() => dispatch(authActions.setIsIdentomat(true))}
                  style={{ color: "#163165", cursor: "pointer" }}
                >
                  {f("pay-phone-text-3")}
                </a>
              </div>
              {!checkUserObj?.isRegistered && (
                <div class="form-check mt-4">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value={agreeImedil}
                    onChange={(e) => setAgreeImedil(e.target.checked)}
                    id="flexCheckDefault"
                  />
                  <label
                    class="form-check-label aggreement-type"
                    for="flexCheckDefault"
                    style={{ textAlign: "left" }}
                  >
                    {f("agreementForRegister")}
                  </label>
                </div>
              )}
            </div>
          )}
        </div>
        {currentWizard === 2 && (
          <div className="timer-class text-center">
            {showPinInput && (
              <ConfirmPin
                autoFocus={true}
                pinTimer={pinTimer}
                onChangePinCode={(newPinCode) => setPinCode(newPinCode)}
                pinCodeDisabled={pinCodeDisabled}
              />
            )}
            <div
              style={{
                cursor: !pinCodeDisabled ? "unset" : "pointer",
                opacity: !pinCodeDisabled ? "0.5" : "1",
              }}
              className="timer-sms-send mt-3"
              onClick={() => {
                if (pinCodeDisabled) dispatch(authActions.getLoginSendOTP(pId));
              }}
            >
              {f("get-sms-code-again")}
            </div>
          </div>
        )}
        {currentWizard === 3 && (
          <>
            <div className="form-floating pb-3">
              <input
                type="password"
                className={
                  "form-control" +
                  (false ? " error-input-style" : "") +
                  `${passwordError ? " is-invalid" : ""}`
                }
                id="floatingInput"
                value={newPassword}
                placeholder="Input"
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  handleNewPasswordChange(e);
                }}
                autoComplete="off"
                autoFocus
              />
              <label htmlFor="floatingInput">{f("new-password")}</label>
            </div>
            <div className="form-floating pb-1">
              <input
                type="password"
                className={
                  "form-control" +
                  (false ? " error-input-style" : "") +
                  `${passwordError ? " is-invalid" : ""}`
                }
                id="floatingInput"
                value={repeateNewPassword}
                placeholder="Input"
                onChange={(e) => {
                  setRepeateNewPassword(e.target.value);
                  handleRepeateNewPasswordChange(e);
                }}
                autoComplete="off"
              />
              <label htmlFor="floatingInput">{f("repeat-new-password")}</label>
            </div>
            {Array?.isArray(exceptionCode) && (
              <StrongPasswordValidation exceptionCode={exceptionCode} f={f} />
            )}
            {anyPasswordHasSpace && (
              <span className="error-text-style">
                {f("passwrod-has-space")}
              </span>
            )}
            {message && <span className="error-text-style">{message}</span>}
          </>
        )}
      </div>
      <div className="text-center pt-4 ms-4 me-4">
        <button
          className="btn btn-primary login-button"
          disabled={
            pId === "" ||
            (!checkUserObj?.isRegistered &&
              currentWizard === 1 &&
              !agreeImedil) ||
            (currentWizard === 2 && pinCode === 0) ||
            (currentWizard === 3 &&
              (newPassword === "" ||
                repeateNewPassword === "" ||
                anyPasswordHasSpace)) ||
            loading
          }
          onClick={() => {
            handleWizardChange();
            if (
              currentWizard === 0 &&
              checkUserObj?.isRegistered &&
              checkUserObj?.isClient &&
              checkUserObj?.maskedMobile !== null
            ) {
              setLoginWithCode(true);
            }
          }}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          ) : currentWizard === 3 ? (
            f("profileMain.agree")
          ) : currentWizard !== 1 ? (
            f("next")
          ) : (
            f("getSMScode")
          )}
          {/* {currentWizard === 3
            ? f("profileMain.agree")
            : currentWizard !== 1
            ? f("next")
            : f("getSMScode")} */}
        </button>
      </div>
      {currentWizard === 3 && (
        <div
          onClick={() => {
            setCurrentWizard(2);
          }}
          className="text-center mt-3 back-parag"
        >
          <ArrowLeftIcon />
          {f("profileMain.back")}
        </div>
      )}
    </div>
  );
};

export default AuthorizationCode;
